/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
export const GET_ALL_REBATE_PROGRAMS = 'GET_ALL_REBATE_PROGRAMS';
export const SET_CREATE_UTIL_TAPE_DATA = 'SET_CREATE_UTIL_TAPE_DATA';
export const GET_MANUFACTURERS_BY_PQR = 'GET_MANUFACTURERS_BY_PQR';
export const CALCULATE_INVOICE = 'CALCULATE_INVOICE';
export const SET_DEFAULT_QTR = 'SET_DEFAULT_QTR';
export const SET_CMS_REPORTING_GRPS = 'SET_CMS_REPORTING_GRPS';
export const REBATE_PRGBY_CMS = 'REBATE_PRGBY_CMS';
export const SET_ERROR_MESSAGES = 'SET_ERROR_MESSAGES';
export const RESET_CREATE_UTILIZATION_TAP_STORE =
  'RESET_CREATE_UTILIZATION_TAP_STORE';
export const UPDATE_QUARTER = 'UPDATE_QUARTER';
